import React, { useState } from 'react';

import SearchBodyParts from '@components/ea/SearchBodyParts';

import SatButton from '@components/common/satUI/SatButton';
import SatSelect from '@components/common/satUI/SatSelect';
import SatModal from '@components/common/satUI/SatModal';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

const ConditionInfo = props => {
  const {
    rowData,
    index,
    totalLength,
    deleteBtnAvailable,
    onDelete,
    onAdd,
    onChangeData,
    conditionData,
    showErrorCheckMsg,
  } = props;

  const [searchVisible, setSearchVisible] = useState(false);

  const selectOptionList = [
    { label: '1년', value: '1' },
    { label: '2년', value: '2' },
    { label: '3년', value: '3' },
    { label: '4년', value: '4' },
    { label: '5년', value: '5' },
    { label: '전기간', value: '99' },
  ];

  const selectOptionMonthList = [
    { label: '1개월', value: '1' },
    { label: '2개월', value: '2' },
    { label: '3개월', value: '3' },
    { label: '4개월', value: '4' },
    { label: '5개월', value: '5' },
    { label: '6개월', value: '6' },
    { label: '7개월', value: '7' },
    { label: '8개월', value: '8' },
    { label: '9개월', value: '9' },
    { label: '10개월', value: '10' },
    { label: '11개월', value: '11' },
  ];

  // 질병명 선택
  const handleInputDiseaseName = value => {
    setSearchVisible(false);
    onChangeData(index, {
      ...rowData,
      cdVal1: value.code,
      cdDsc: value.name,
    });
  };

  return (
    <React.Fragment>
      <div className="infor-list">
        {index === 0 && (
          <h2 className="tit-con">특정 신체부위·질병 면책 가입조건</h2>
        )}
        <div className="insu-box item-r">
          {deleteBtnAvailable && (
            <span className="txt-del" onClick={() => onDelete(index)}>
              삭제
            </span>
          )}
          <table className="medi-history">
            <caption>정보선택</caption>
            <colgroup>
              <col style={{ width: '10rem' }} />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">{index + 1}.부위 및 질병</th>
                <td>
                  <div
                    className={`input-wrap u-line${
                      rowData.cdDsc ? ' val' : ''
                    }`}
                    onClick={() => setSearchVisible(true)}
                  >
                    <div className="input-area">
                      <span className="txt-box line1">
                        {rowData.cdDsc ? rowData.cdDsc : '입력'}
                      </span>
                    </div>
                    <SatButton
                      styleClass="ico ico-search"
                      onClick={() => setSearchVisible(true)}
                    />
                  </div>
                  <SatValidationErrMsg
                    visible={showErrorCheckMsg && rowData.cdDsc === ''}
                    type="error"
                    message="내용을 확인하고 선택해 주세요."
                  />
                </td>
              </tr>
              <tr>
                <th scope="row">면책기간</th>
                <td>
                  <SatSelect
                    value={rowData.year ?? '0'}
                    title="면책기간"
                    initOption={{ label: '선택없음', value: '0' }}
                    options={selectOptionList}
                    onChange={value => {
                      onChangeData(index, {
                        ...rowData,
                        year: value.value,
                        month:
                          Number(value.value || 0) >= 5 ? '0' : rowData.month,
                        period:
                          Number(value.value || 0) == 99 ? '전기간' :
                          ((Number(value.value || 0) == 0
                            ? ''
                            : value.value + '년 ') +
                          (Number(rowData.month || 0) == 0
                            ? ''
                            : rowData.month + '개월')),
                      });
                    }}
                    customStyleClass={'w-200'}
                  />
                  <SatValidationErrMsg
                    visible={showErrorCheckMsg && rowData.period === ''}
                    type="error"
                    message="내용을 확인하고 선택해 주세요."
                  />
                </td>
                <td>
                  <SatSelect
                    value={rowData.month ?? '0'}
                    title="면책기간"
                    initOption={{ label: '선택없음', value: '0' }}
                    options={selectOptionMonthList}
                    disabled={Number(rowData.year || 0) >= 5 ? true : false}
                    onChange={value => {
                      onChangeData(index, {
                        ...rowData,
                        month: value.value,
                        period:
                          (Number(rowData.year || 0) == 0
                            ? ''
                            : rowData.year + '년 ') +
                          (Number(value.value || 0) == 0
                            ? ''
                            : value.value + '개월'),
                      });
                    }}
                    customStyleClass={'w-200'}
                  />
                  <SatValidationErrMsg
                    visible={showErrorCheckMsg && rowData.period === ''}
                    type="error"
                    message="내용을 확인하고 선택해 주세요."
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {index + 1 === totalLength && totalLength < 6 && (
          <div className="box-btns-center mgb-20">
            <SatButton
              styleClass="btn-m b-blue2 w-328"
              iconStyleClass="ico ico-add4"
              label="추가등록"
              onClick={onAdd}
            />
          </div>
        )}
      </div>
      <SatModal
        visible={searchVisible}
        setVisible={() => setSearchVisible(false)}
        type="fullPop"
      >
        <SearchBodyParts
          onSelect={handleInputDiseaseName}
          diseaseCode={rowData.cdVal1}
          diseaseName={rowData.cdDsc}
          onClose={() => setSearchVisible(false)}
          conditionData={conditionData}
        />
      </SatModal>
    </React.Fragment>
  );
};

export default ConditionInfo;
